export enum PAPER_SIZE {
  A4 = 'A4 (210mm × 297mm)',
  A3 = 'A3 (297mm × 420mm)',
  LETTER = 'Letter (8.5in × 11in)',
  LEGAL = 'Legal (8.5in × 14in)',
}

export enum SCOPE {
  ALL_PROJECTS = 'ALL_PROJECTS',
  SPECIFIC_PROJECTS = 'SPECIFIC_PROJECTS',
}

export enum STATUS {
  PUBLISHED = 'published',
  DRAFT = 'draft',
  UNPUBLISHED = 'unpublished',
}
